import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Iterable } from 'immutable';
import isFunction from 'lodash/isFunction';
import { userSettings as userSettingsSelector } from '@Containers/UserDetails/UserDetailsSelectors';

export function useUserSettings(callback) {
  const userSettings = useSelector(userSettingsSelector);

  useEffect(() => {
    if (userSettings && isFunction(callback)) {
      return callback(
        Iterable.isIterable(userSettings) ? userSettings.toJS() : userSettings
      );
    }
  }, [ userSettings ]);
}
